<template>
  <div class="container">
    <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/award/1.png"/>
    <div class="back-btn" @click="handleBack">
      <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png"/>
      <span>返回抽奖</span>
    </div>
    <div class="award-list">
      <div class="item" v-for="item in awardList" :key="item.id">
        <img class="cover" :src="item.cover"/>
        <p class="name">{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      awardList:[],
    }
  },
  created(){
    this.getList();
  },
  methods:{
    getList(){
      let query = this.$route.query;
      let aid = query.aid;
      if(!aid){
        return false;
      }
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/lottery/prize/list?activity_id=${aid}&page=1&page_size=50`,
        method: "get",
      }).then((res) => {
        if(res.data.error_code===0){
          this.awardList = res.data.data.list.map((item)=>{
            return {
              id:item.prize_id,
              cover:item.cover_image_url,
              name:item.title,
            };
          });
        }
      });
    },
    handleBack(){
      this.$emit('close');
    },
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/new-draw-bg1.png);
  background-size: 100% 100%;
  background-position: center top;
  overflow: hidden;
}
.top-title{
  position: absolute;
  width: 304px;
  height: auto;
  top:12px;
  left:0;
  right:0;
  margin:0 auto;
  z-index: 100;
}
.back-btn{
  position: fixed;
  top:14px;
  right:10px;
  display: flex;
  align-items: center;
  z-index: 101;
  img{
    width: 40px;
    height: 40px;
  }
  span{
    font-size: 16px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    margin-left: 8px;
  }
}
.award-list{
  position: absolute;
  top: 100px;
  left:0;
  right:0;
  bottom: 24px;
  margin:0 auto;
  width: 294px;
  border-radius: 30px;
  background: rgba(78, 0, 0, 0.55);
  border: 2px solid rgba(255, 255, 255, 1);
  padding:52px 23px 23px 23px;
  overflow: hidden auto;
  .item{
    display: flex;
    text-align: left;
    align-items: center;
    margin-bottom: 18px;
    .cover{
      width: 90px;
      height: 90px;
      border-radius: 16px;
      margin-right: 15px;
    }
    .name{
      font-size: 16px;
      letter-spacing: 0px;
      line-height: 22px;
      color: rgba(255, 255, 255, 1);
      text-align: left;
      vertical-align: top;
    }
  }
}
</style>